module.exports = __webpack_public_path__ + "static/media/Rachel Goldman.0090e4e8.png";